import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Table, Button, Spinner, Alert, Badge } from 'react-bootstrap'
import { usersAPI } from '../../services/usersApi'

const UsersList = ({ currentUser }) => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadUsers()
  }, [])

  const loadUsers = async () => {
    try {
      setLoading(true)
      const response = await usersAPI.list()
      setUsers(response.data)
      setError(null)
    } catch (err) {
      setError('Ошибка загрузки пользователей')
      console.error('Error loading users:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (id) => {
    if (!window.confirm('Вы уверены, что хотите удалить этого пользователя?')) {
      return
    }

    try {
      await usersAPI.delete(id)
      setUsers(users.filter(u => u.id !== id))
    } catch (err) {
      alert('Ошибка при удалении пользователя')
      console.error('Error deleting user:', err)
    }
  }

  const getRoleBadge = (user) => {
    if (user.roles?.includes('admin')) {
      return <Badge bg="danger">Админ</Badge>
    } else if (user.roles?.includes('foreman')) {
      return <Badge bg="primary">Прораб</Badge>
    } else {
      return <Badge bg="secondary">Без роли</Badge>
    }
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <Spinner animation="border" />
      </div>
    )
  }

  if (error) {
    return <Alert variant="danger">{error}</Alert>
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="mb-0">Пользователи</h1>
        <Link to="/users/new" className="btn btn-primary btn-sm">
          Создать нового пользователя
        </Link>
      </div>

      {users.length === 0 ? (
        <Alert variant="info">Нет пользователей</Alert>
      ) : (
        <div className="table-responsive">
          <Table striped hover>
            <thead className="table-dark">
              <tr>
                <th>№</th>
                <th>Email</th>
                <th>Роль</th>
                <th>Дата создания</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr key={user.id}>
                  <td>{index + 1}</td>
                  <td>{user.email}</td>
                  <td>{getRoleBadge(user)}</td>
                  <td>{new Date(user.created_at).toLocaleDateString('ru-RU')}</td>
                  <td>
                    <Link
                      to={`/users/${user.id}/edit`}
                      className="btn btn-sm btn-outline-primary"
                    >
                      Редактировать
                    </Link>
                  </td>
                  <td>
                    {user.id !== currentUser?.id ? (
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleDelete(user.id)}
                      >
                        Удалить
                      </Button>
                    ) : (
                      <span className="text-muted">Текущий пользователь</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  )
}

export default UsersList
